/*
 * Formatadores do Intl guardados, um por idioma e opções: criar um
 * `Intl.DateTimeFormat`/`NumberFormat` é caro (carrega os dados do idioma), e
 * as datas e números da lista, do tópico e do perfil eram formatados criando
 * um novo a cada chamada, em todo redesenho. O idioma da página não muda
 * depois de carregada, então os formatadores valem até ela ser recarregada.
 */
const cache = new Map();
function cached(kind, locale, options, make) {
  const key = `${kind}|${String(locale)}|${JSON.stringify(options)}`;
  let formatter = cache.get(key);
  if (!formatter) {
    formatter = make();
    cache.set(key, formatter);
  }
  return formatter;
}
export function dateFormat(locale, options = {}) {
  return cached('date', locale, options, () => new Intl.DateTimeFormat(locale, options));
}
export function numberFormat(locale, options = {}) {
  return cached('number', locale, options, () => new Intl.NumberFormat(locale, options));
}
export function displayNames(locale, options) {
  return cached('names', locale, options, () => new Intl.DisplayNames(locale, options));
}
flarum.reg.add('ramon-canela', 'forum/utils/intl', { dateFormat: dateFormat,numberFormat: numberFormat,displayNames: displayNames, });